var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotleadimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 32,
    viewBox: "0 0 80 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 31.7571H2.82353H75.2941H78.1176H80V12.2632C60.2353 -9.0968 53.6471 6.75091 49.8824 10.1961C40.4706 21.2206 33.8824 17.0862 30.1176 14.3301C22.5882 6.75074 20.7059 12.263 18.8235 15.7081C14.3059 22.3228 4.39216 18.4643 0 15.7081V31.7571Z",
    fill: "url(#paint0_linear_2513_32131)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.682983 15.8064C5.07514 18.5625 14.3059 22.3229 18.8235 15.7082C20.7059 12.2631 22.5882 6.75084 30.1177 14.3302C33.8824 17.0863 40.4706 21.2207 49.8824 10.1962C53.6471 6.75102 59.6115 -9.55346 79.3762 11.8065",
    stroke: "#E3B894",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2513_32131",
    x1: 40,
    y1: 1.30647,
    x2: 40.7568,
    y2: 46.7934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354986,
    stopColor: "#FCE6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792803,
    stopColor: "#F8EEE6",
    stopOpacity: 0.26
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotleadimg);
export default __webpack_public_path__ + "static/media/hotleadimg.720730784a3fe6d7d07f27398e17272b.svg";
export { ForwardRef as ReactComponent };